export const generateUniqueId = () => {
	const random = Math.floor(Math.random() * 100);
	const date = Date.now();
	return random + date;
};
